import React from 'react';
import {
  Page,
  SkeletonBodyText,
} from '@shopify/polaris';
import DashboardComponent from "../../components/DashboardComponent";
import ChooseOperationModal from "../../components/ChooseOperationModal";
import Cookies from "js-cookie";
import { Helmet } from 'react-helmet';

export class DashboardPage extends React.Component {

  state = {
    tags: [],
    isLoading: true,
    tagCount: 0,
    productCount: 0,
    customerTags: [],
    customerCount: 0,
    isDev: false,
    tagChangesStore: 0,
    tagChangesGlobal: 0,
    operationsModalActive: false
  };

  render() {

    return (
      <div>
        <Helmet>
          <title>Tag Genie - Dashboard</title>
        </Helmet>
        <Page title="Dashboard"
          primaryAction={{ content: 'Create Bulk Tag Operation', onAction: this.toggleOperationsModal }}        >
          {this.state.isLoading && <SkeletonBodyText lines="20" />}
          {!this.state.isLoading && <DashboardComponent
            tags={this.state.tags}
            productCount={this.state.productCount}
            customerTags={this.state.customerTags}
            customerCount={this.state.customerCount}
            orderTags={this.state.orderTags}
            orderCount={this.state.orderCount}
            isDev={this.state.isDev}
            // creditsTotal={this.state.creditsTotal}
            // creditsUsed={this.state.creditsUsed}
            tagChangesGlobal={this.state.tagChangesGlobal}
            tagChangesStore={this.state.tagChangesStore}
            onRefreshData={this.refresh}
            onCreateNewOperation={this.fetchDashboardData} />}
          <ChooseOperationModal active={this.state.operationsModalActive} onClose={this.toggleOperationsModal} />
        </Page>
      </div>
    );
  }

  fetchDashboardData = () => {
    fetch('api/dashboard', {
      method: 'get',
      headers: new Headers({
        'Authorization': 'Bearer ' + Cookies.get("__genie")
      })
    })
      .then(response => { return response.json() })
      .then(data => {
        this.setState({
          isLoading: false,
          tags: data.tags,
          productCount: data.productCount,
          isDev: data.isDev,
          tagChangesStore: data.tagChangesStore,
          tagChangesGlobal: data.tagChangesGlobal,
          customerCount: data.customerCount,
          customerTags: data.customerTags,
          orderCount: data.orderCount,
          orderTags: data.orderTags
        });
      });
  }

  toggleOperationsModal = () => {
    this.props.history.push("/operations/new");
  }

  componentDidMount = () => {
    this.fetchDashboardData();
  }

  componentWillUnmount() {
  }

}

export default DashboardPage;